import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { MemoryHistory } from 'history';
import { useSelector } from 'react-redux';
import GoBackContent from './go-back.content';
import formFieldsSelectors from '../../../store/selectors/form-fields.selectors';

const GoBack: React.FunctionComponent = () => {
  const history = useHistory() as MemoryHistory;
  const redirectedFromClientsPath = useSelector(
    formFieldsSelectors.getIsRedirectedFromClients
  );

  const onClickHandler = useCallback(() => {
    if (!history.index) {
      if (redirectedFromClientsPath.length) {
        window.location.href = `${redirectedFromClientsPath}?go_to_existing_clients=true`;
        return null;
      }

      return window.history.length ? window.history.back() : history.push('/');
    }

    return history.goBack();
  }, [history, redirectedFromClientsPath]);
  return <GoBackContent onClickHandler={onClickHandler} />;
};

export default GoBack;
